export default function CHighlightedText({
  text,
  firstHalf = false,
  className,
  ...props
}) {
  const highLighText = (text) => {
    const items = text?.split(" ");
    if (items?.length == 1) {
      return (
        <>
          <span className={!firstHalf ? "text-primary" : ""}>
            {items[0].substr(0, Math.floor(items[0].length / 2))}
          </span>
          <span className={firstHalf ? "text-primary" : ""}>
            {items[0].substr(Math.floor(items[0].length / 2))}
          </span>
        </>
      );
    } else {
      return (
        <>
          <span className={!firstHalf ? "text-primary" : ""}>
            {items
              ?.slice(0, Math.floor(items?.length / 2))
              .map((el) => el + " ")}
          </span>
          <span className={firstHalf ? "text-primary" : ""}>
            {items?.slice(Math.floor(items.length / 2)).map((el) => el + " ")}
          </span>
        </>
      );
    }
  };

  return (
    <>
      <h2
        className={`text-grayCustom my-0 mt-2 font-semibold md:text-[40px] leading-7  md:leading-[40px] ${className}`}
        {...props}
      >
        {highLighText(text)}
      </h2>
    </>
  );
}
